import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { TextField, MenuItem } from "@mui/material";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";

function DailyCallReport() {
    const loggedInUser =
        JSON.parse(localStorage.getItem("user"));

    const userRole =
        (loggedInUser?.role || "").toLowerCase();

    const loggedEmployeeId =
        loggedInUser?.empId || "";

    const loggedBranchId =
        loggedInUser?.branchId || "";

    const allBranches =
        (loggedInUser?.allBranches || "N") === "Y";

    const branchManager =
        (loggedInUser?.branchManager || "N") === "Y";

    const isAdmin =
        userRole === "admin";

    const isManager =
        userRole === "manager";

    const isUser =
        userRole === "user";
    const navigate = useNavigate();
    const [locationFilter, setLocationFilter] = useState("");
    const location = useLocation();   // ✅ THIS WAS MISSING USAGE
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [employee, setEmployee] = useState("");
    useEffect(() => {

        // USER -> auto select own name
        if (isUser) {

            setEmployee(
                loggedEmployeeId || ""
            );
        }

    }, [isUser, loggedInUser]);
    const [organization, setOrganization] = useState("");
    const [customerType, setCustomerType] = useState("");
    const [callType, setCallType] = useState("");
    const [status, setStatus] = useState("");

    const [employees, setEmployees] = useState([]);
    const [locations, setLocations] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [minValue, setMinValue] = useState("");
    const [maxValue, setMaxValue] = useState("");
    const [followUpDate, setFollowUpDate] = useState("");
    const [search, setSearch] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const from = params.get("fromDate");
        const to = params.get("toDate");
        const emp = params.get("employee");
        const stat = params.get("status");
        const minValueParam = params.get("minValue");
        const callTypeParam = params.get("callType");

        console.log("URL PARAMS:", {
            from,
            to,
            emp,
            stat,
            callTypeParam,
            minValueParam
        });

        // ✅ CASE 1: URL has ANY filters
        if (from || to || minValueParam || callTypeParam || emp || stat) {

            // ✅ ONLY update date if URL actually has date
            if (from && to) {
                setFromDate(from);
                setToDate(to);
            }

            setEmployee(emp ? Number(emp) : "");
            setStatus(stat || "");

            if (minValueParam) {
                setMinValue(minValueParam);
            }

            // ✅ USE EXISTING DATE IF NOT PROVIDED
            const finalFromDate = from || fromDate;
            const finalToDate = to || toDate;

            loadData({
                fromDate: finalFromDate,
                toDate: finalToDate,
                employee: emp || undefined,
                status: stat || undefined,
                callType: callTypeParam || undefined,
                minValue: minValueParam || undefined,
                location: params.get("location") || undefined,
                organization: params.get("organization") || undefined,
                customerType: params.get("customerType") || undefined,
                maxValue: params.get("maxValue") || undefined,
                followUpDate: params.get("followUpDate") || undefined
            });

        }
        // ✅ CASE 2: FIRST LOAD ONLY
        else if (!fromDate && !toDate) {

            const today = new Date().toLocaleDateString("en-CA");

            setFromDate(today);
            setToDate(today);

            loadData({
                fromDate: today,
                toDate: today
            });
        }

        // ✅ DROPDOWNS (safe)
        API.get("/DailyCallReport/dropdowns-all")
            .then(res => {

                let employeeData = res.data.employees || [];

                // ADMIN + AllBranches=Y
                if (isAdmin && allBranches) {

                    // show all
                }

                // ADMIN + AllBranches=N
                else if (isAdmin && !allBranches) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=Y
                else if (isManager && branchManager) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=N
                else if (isManager && !branchManager) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                // USER
                else if (isUser) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                setEmployees(employeeData);

                setLocations(res.data.locations || []);
                setOrganizations(res.data.organizations || []);
            });

    }, []);

    const loadDropdowns = (finalFromDate, finalToDate) => {

        API.get(
            `/DailyCallReport/dropdowns?fromDate=${finalFromDate}&toDate=${finalToDate}`
        )
            .then(res => {

                let employeeData = res.data.employees || [];

                // ADMIN + AllBranches=Y
                if (isAdmin && allBranches) {

                    // show all
                }

                // ADMIN + AllBranches=N
                else if (isAdmin && !allBranches) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=Y
                else if (isManager && branchManager) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=N
                else if (isManager && !branchManager) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                // USER
                else if (isUser) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                setEmployees(employeeData);

                setLocations(res.data.locations || []);
                setOrganizations(res.data.organizations || []);
            });
    };

    const loadData = (filters = {}) => {

        let query = [];

        if (filters.fromDate) query.push(`fromDate=${filters.fromDate}`);
        if (filters.toDate) query.push(`toDate=${filters.toDate}`);
        if (
            filters.employee !== "" &&
            filters.employee !== undefined &&
            filters.employee !== null
        ) {
            query.push(`employee=${filters.employee}`);
        }
        if (filters.location) query.push(`location=${filters.location}`);
        if (filters.organization) query.push(`organization=${filters.organization}`);
        if (filters.customerType) query.push(`customerType=${filters.customerType}`);
        if (filters.callType) query.push(`callType=${filters.callType}`);
        if (filters.status) query.push(`status=${filters.status}`);
        if (filters.minValue) query.push(`minValue=${filters.minValue}`);
        if (filters.maxValue) query.push(`maxValue=${filters.maxValue}`);
        if (filters.followUpDate) query.push(`followUpDate=${filters.followUpDate}`);

        const url = `/DailyCallReport${query.length ? "?" + query.join("&") : ""}`;

        console.log("FINAL API URL:", url); // 🔥 DEBUG

        API.get(url)
            .then(res => {

                const enrichedData =
                    (res.data.data || []).map(call => {

                        const emp = employees.find(
                            e => Number(e.id) === Number(call.employeeId)
                        );

                        return {

                            ...call,

                            employeeName:
                                call.employeeName || "",

                            empCode:
                                emp?.empCode ||
                                call.empId ||
                                "",

                            branchName:
                                emp?.branchName ||
                                call.branchName ||
                                ""

                        };

                    });

                setData(enrichedData);

            });
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        const blob = new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })]);
        saveAs(blob, "DailyCallReport.xlsx");
    };

    const formatDate = (d) => {
        if (!d) return "";
        const dt = new Date(d);
        return `${dt.getDate()}/${dt.getMonth() + 1}/${dt.getFullYear()}`;
    };

    const handleLast7Days = () => {
        const today = new Date();
        const last7 = new Date();

        last7.setDate(today.getDate() - 7);

        const format = (d) => d.toLocaleDateString("en-CA");

        const from = format(last7);
        const to = format(today);

        setFromDate(from);
        setToDate(to);

        loadData({
            fromDate: from,
            toDate: to,
            status: status   // 🔥 THIS IS THE FIX
        });
    };

    const handleReset = () => {

        // reset all filters
        setEmployee("");
        setLocationFilter("");
        setOrganization("");
        setCustomerType("");
        setCallType("");
        setStatus("");
        setMinValue("");
        setMaxValue("");
        setFollowUpDate("");

        const today = new Date().toLocaleDateString("en-CA");

        setFromDate(today);
        setToDate(today);

        // ✅ FORCE CLEAN DATA LOAD
        loadData({
            fromDate: today,
            toDate: today
        });

        // ✅ CLEAN URL
        navigate("/app/daily-call-report");
    };
    const handleFilter = () => {
        setPage(1);

        const today = new Date().toLocaleDateString("en-CA");

        const finalFromDate = fromDate || today;
        const finalToDate = toDate || today;

        loadData({
            fromDate: finalFromDate,
            toDate: finalToDate,
            employee,
            location: locationFilter,
            organization,
            customerType,
            callType,
            status,
            minValue,
            maxValue,
            followUpDate
        });

        const params = new URLSearchParams();

        params.set("fromDate", finalFromDate);
        params.set("toDate", finalToDate);

        if (employee) params.set("employee", employee);
        if (locationFilter) params.set("location", locationFilter);
        if (organization) params.set("organization", organization);
        if (customerType) params.set("customerType", customerType);
        if (status) params.set("status", status);
        if (callType) params.set("callType", callType);
        if (minValue) params.set("minValue", minValue);
        if (maxValue) params.set("maxValue", maxValue);
        if (followUpDate) params.set("followUpDate", followUpDate);

        window.history.replaceState(
            {},
            "",
            `/app/daily-call-report?${params.toString()}`
        );

        loadDropdowns(
            finalFromDate,
            finalToDate
        );
    };

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // filtering (if search exists)
    const filteredData = data

        // ACCESS CONTROL
        .filter(x => {

            // ADMIN + AllBranches=Y
            if (isAdmin && allBranches) {
                return true;
            }

            // ADMIN + AllBranches=N
            if (isAdmin && !allBranches) {

                return x.branchName === loggedInUser?.branchName;
            }

            // MANAGER + BranchManager=Y
            if (isManager && branchManager) {

                return x.branchName === loggedInUser?.branchName;
            }

            // MANAGER + BranchManager=N
            if (isManager && !branchManager) {

                return x.employeeId === loggedEmployeeId;
            }

            // USER
            if (isUser) {

                return x.employeeId === loggedEmployeeId;
            }

            return false;
        })

    // pagination
    const indexOfLast = page * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const totalValue = filteredData.reduce(
        (sum, item) =>
            sum + Number(item.potentialValue || 0),
        0
    );    

    const highlightText = (text) => {
        const term = (search || "").toLowerCase().trim();
        if (!term) return text;

        const value = String(text || "");
        const parts = value.split(new RegExp(`(${term})`, "gi"));
        return parts.map((part, i) =>
            part.toLowerCase() === term ? (
                <span
                    key={i}
                    style={{
                        backgroundColor: "#ffeaa7",
                        fontWeight: "bold"
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };
    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <h2>Daily Call Report</h2>
            </div>

            {/* ROW 1 */}
            <div style={styles.row}>
                <TextField type="date" label="From" value={fromDate} onChange={e => setFromDate(e.target.value)} fullWidth size="small" InputLabelProps={{ shrink: true }} sx={styles.inputStyle} />
                <TextField type="date" label="To" value={toDate} onChange={e => setToDate(e.target.value)} fullWidth size="small" InputLabelProps={{ shrink: true }} sx={styles.inputStyle} />

                <TextField
                    select
                    label="Employee"
                    value={employee}
                    disabled={isUser}
                    onChange={(e) => setEmployee(e.target.value)}
                    size="small"
                    sx={{
                        ...styles.inputStyle,
                        //minWidth: "370px"
                        width: "250px"
                    }}
                >
                    {!isUser && (
                        <MenuItem value="" sx={styles.menuItem}>
                            All
                        </MenuItem>
                    )}

                    {[...employees]

                        .sort((a, b) =>
                            a.empName.localeCompare(b.empName)
                        )

                        .map(emp => (

                            <MenuItem
                                key={emp.id}
                                value={emp.id}
                                sx={styles.menuItem}
                            >
                                <div style={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center"
                                }}>

                                    {/* EMPLOYEE */}
                                    <span style={{
                                        width: "160px",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {emp.empName}
                                    </span>

                                    {/* BRANCH */}
                                    <span style={{
                                        width: "140px"
                                    }}>
                                        {"-> "} {emp.branchName}
                                    </span>

                                    {/* MOBILE */}
                                    <span>
                                        {"-> "} {emp.mobileNo}
                                    </span>

                                </div>
                            </MenuItem>

                        ))}
                </TextField>

                <TextField
                    select
                    label="Location"
                    value={locationFilter}
                    onChange={e => setLocationFilter(e.target.value)}
                    fullWidth
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    {locations.map(l => (
                        <MenuItem key={l} value={l} sx={styles.menuItem}>
                            {l}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField select label="Organization" value={organization} onChange={e => setOrganization(e.target.value)} fullWidth size="small" sx={styles.inputStyle}>
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    {organizations.map(o => <MenuItem key={o} value={o} sx={styles.menuItem}>{o}</MenuItem>)}
                </TextField>
            </div>

            {/* ROW 2 */}
            <div style={styles.filterRow}>

                <TextField
                    select
                    label="Customer Type"
                    value={customerType}
                    onChange={(e) => setCustomerType(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    <MenuItem value="Banking" sx={styles.menuItem}>Banking</MenuItem>
                    <MenuItem value="Non Banking" sx={styles.menuItem}>Non Banking</MenuItem>
                    <MenuItem value="Institutional" sx={styles.menuItem}>Institutional</MenuItem>
                </TextField>

                <TextField
                    select
                    label="Call Type"
                    value={callType}
                    onChange={(e) => {
                        console.log("CALL TYPE SELECTED:", e.target.value);
                        setCallType(e.target.value);
                    }}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    <MenuItem value="Marketing" sx={styles.menuItem}>Marketing</MenuItem>
                    <MenuItem value="Follow Up" sx={styles.menuItem}>Follow Up</MenuItem>
                    <MenuItem value="Negotiation" sx={styles.menuItem}>Negotiation</MenuItem>
                    <MenuItem value="Collection" sx={styles.menuItem}>Collection</MenuItem>
                    <MenuItem value="Service" sx={styles.menuItem}>Service</MenuItem>
                </TextField>

                <TextField
                    select
                    label="Status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    <MenuItem value="Active" sx={styles.menuItem}>Active</MenuItem>
                    <MenuItem value="Closed" sx={styles.menuItem}>Closed</MenuItem>
                    <MenuItem value="Pending" sx={styles.menuItem}>Pending</MenuItem>
                </TextField>

                <TextField
                    label="Min Value"
                    value={minValue}
                    onChange={(e) => setMinValue(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                />

                <TextField
                    label="Max Value"
                    value={maxValue}
                    onChange={(e) => setMaxValue(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                />

                <TextField
                    label="Follow-up"
                    type="date"
                    value={followUpDate}
                    onChange={(e) => setFollowUpDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ ...styles.inputStyle, width: "180px" }}   // ✅ FORCE SAME WIDTH
                />

            </div>

            {/* ACTION */}
            <div style={styles.row}>

                <button style={styles.filterBtn} onClick={handleFilter}>
                    Filter
                </button>
                <button style={styles.last7Btn} onClick={handleLast7Days}>
                    Last 7 Days
                </button>

                <button style={styles.resetBtn} onClick={handleReset}>
                    Reset
                </button>

                <div style={styles.searchBox}>
                    <span style={styles.searchIcon}>🔍</span>

                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Escape") setSearch("");
                            if (e.key === "Enter") console.log("Enter pressed");
                        }}
                        style={styles.searchInput}
                    />

                    {search && (
                        <span
                            style={styles.clearIcon}
                            onClick={() => setSearch("")}
                            title="Clear"
                        >
                            ✕
                        </span>
                    )}
                </div>

                <button style={styles.exportBtn} onClick={exportToExcel}>
                    Export
                </button>

                <span style={{ marginLeft: "10px" }}>Rows per page:</span>

                <select
                    value={rowsPerPage}
                    onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setPage(1);
                    }}
                    style={styles.select}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </select>
            </div>
            <div style={{
                display: "flex",
                gap: "10px",
                marginBottom: "10px",
                flexWrap: "wrap"
            }}>
                {/* TOTAL VALUE */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#fff7e6",
                    border: "1px solid #f39c12"
                }}>
                    <div>Total Value</div>
                    <strong>
                        ₹ {totalValue.toLocaleString("en-IN")}
                    </strong>
                </div>

                {/* TOTAL */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#e3f2fd",
                    border: "1px solid #1e90ff"
                }}>
                    <div>Total Calls</div>
                    <strong>{filteredData.length}</strong>
                </div>

                {/* ACTIVE */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#e8f5e9",
                    border: "1px solid #2ecc71"
                }}>
                    <div>Active</div>
                    <strong>
                        {filteredData.filter(x => x.status === "Active").length}
                    </strong>
                </div>

                {/* PENDING */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#fff3e0",
                    border: "1px solid #ffa502"
                }}>
                    <div>Pending</div>
                    <strong>
                        {filteredData.filter(x => x.status === "Pending").length}
                    </strong>
                </div>

                {/* CLOSED */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#f1f2f6",
                    border: "1px solid #57606f"
                }}>
                    <div>Closed</div>
                    <strong>
                        {filteredData.filter(x => x.status === "Closed").length}
                    </strong>
                </div>

            </div>

            {/* TABLE */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.tableHeader}>
                        <tr>
                            <th style={styles.th}>Date</th>
                            <th style={styles.th}>Employee</th>
                            <th style={styles.th}>Customer</th>
                            <th style={styles.th}>Location</th>
                            <th style={styles.th}>Customer Type</th>
                            <th style={styles.th}>Organization</th>
                            <th style={styles.th}>Call Type</th>
                            <th style={styles.th}>Value</th>
                            <th style={styles.th}>Follow-up</th>
                            <th style={styles.th}>Status</th>
                        </tr>
                    </thead>

                    <tbody>
    {currentData.length === 0 ? (
        <tr>
            <td colSpan="10" style={{ textAlign: "center" }}>
                No records
            </td>
        </tr>
    ) : currentData.map(x => (
        <tr key={x.id}>
            <td style={styles.td}>{formatDate(x.createdOn)}</td>

            {/*<td style={styles.td}>{highlightText(x.employeeName)}</td>*/}

            <td style={styles.td}>

                <div>
                    <div>
                        {highlightText(x.employeeName)}
                    </div>

                    <div style={{
                        fontSize: "10px",
                        color: "#666",
                        marginTop: "2px"
                    }}>
                        {(x.empCode || "")} {"-> "} {x.branchName || ""}
                    </div>
                </div>

            </td>
            <td 
                style={{
                    ...styles.td,
                    minWidth: "120px",
                    whiteSpace: "normal"
                }}
            >
                {highlightText(x.customerName)}
            </td>

            <td
                style={{
                    ...styles.td,
                    minWidth: "80px",
                    whiteSpace: "normal"
                }}
               >
                {highlightText(x.location)}
            </td>
            <td style={styles.td}>{highlightText(x.customerType)}</td>

            <td
                style={{
                    ...styles.td,
                    minWidth: "120px",
                    whiteSpace: "normal"
                }}
            >
                {highlightText(x.organizationName)}
            </td>
            <td style={styles.td}>{highlightText(x.callType)}</td>

            <td style={styles.td}>
                ₹ {highlightText(x.potentialValue)}
            </td>

            <td style={styles.td}>{formatDate(x.nextFollowUpDate)}</td>
            <td style={styles.td}>{highlightText(x.status)}</td>
        </tr>
    ))}
</tbody>
                </table>
                <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </button>

                    <span>
                        Page {page} of {totalPages}
                    </span>

                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </button>
                </div>
            </div>

        </div>
    );
}

const styles = {
    container: { padding: 5, background: "#f1f2f6", fontFamily: "Verdana", fontSize: "12px", overflowX: "auto" },

    header: {
        background: "#2f3542",
        color: "#fff",
        padding: "6px",
        borderRadius: "6px",
        marginBottom: "10px"
    },

    row: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    row2: {
        display: "flex",
        gap: "10px",
        flexWrap: "nowrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    filterRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    menuItem: {
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    // ✅ INPUT STYLE
    inputStyle: {
        //width: "180px",
        width: "100%",
        maxWidth: "180px",

        "& .MuiOutlinedInput-root": {
            height: "32px",
            fontSize: "12px",
            fontFamily: "Verdana"
        },

        "& .MuiInputBase-input": {
            padding: "8px 10px",
            fontFamily: "Verdana",
            fontSize: "12px"
        },

        "& .MuiInputLabel-root": {
            fontFamily: "Verdana",
            fontSize: "12px"
        }
    },

    // ✅ BUTTON STYLES (CORRECT PLACE)
    filterBtn: {
        background: "#2ed573",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    last7Btn: {
        background: "#2ed573",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    resetBtn: {
        background: "#ff4757",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    exportBtn: {
        background: "#1e90ff",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    // OPTIONAL (for search & dropdown)
    search: {
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    select: {
        padding: "5px",
        fontFamily: "Verdana",
        fontSize: "12px",
        borderRadius: "4px"
    },

    tableWrapper: { width: "100%", overflowX: "auto" },
    table: { width: "100%", borderCollapse: "collapse" },

    tableHeader: { background: "#57606f", color: "#fff" },

    th: { border: "1px solid #ccc", padding: "8px" },
    td: {
        border: "1px solid #ddd",
        padding: "8px",
        whiteSpace: "nowrap"
    },
    searchBox: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "4px 8px",
        background: "#fff",
        width: "180px"
    },

    searchIcon: {
        marginRight: "6px",
        fontSize: "14px",
        color: "#888"
    },

    searchInput: {
        border: "none",
        outline: "none",
        fontFamily: "Verdana",
        fontSize: "12px",
        width: "100%",
        background: "transparent"
    },

    clearIcon: {
        marginLeft: "6px",
        cursor: "pointer",
        fontSize: "12px",
        color: "#999"
    },
    card: {
        flex: 1,
        background: "#ffffff",
        padding: "10px",
        borderRadius: "6px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        textAlign: "center",
        fontSize: "12px"
    }
};
export default DailyCallReport;